import React from 'react';
import PropTypes from 'prop-types';

import Currency from 'components/consumer/Currency';
import IconProtectionPlan from 'components/icons/iconProtectionPlan';
import IconPetProtector from 'components/icons/iconPetProtector';
import ProgressLoaderDots from 'components/essentials/ProgressLoaderDots/ProgressLoaderDots';

const CheckoutSelectedProtectionPlan = ({
  planName,
  planPrice,
  isRemovePPLoading,
  setIsRemovePPLoading,
}) => (
  <div className="relative min-w-[250px] min-h-[50px] ml-auto flex items-center p-[7.5px] bg-white border border-solid border-gray-light5 max-[1023px]:m-0 max-[1023px]:w-full lg:p-[5px] lg:ml-auto lg:min-w-[320px]">
    {isRemovePPLoading ? (
      <ProgressLoaderDots />
    ) : (
      <div className="flex items-center w-full">
        <span className="w-12 h-12">
          {planName.includes('Pet Protector Plan') ? (
            <IconPetProtector />
          ) : (
            <IconProtectionPlan />
          )}
        </span>

        <span className="text-xs font-bold text-gray mx-[.7rem] my-0 tracking-[unset] [white-space:break-spaces]">
          5-year {planName}
          {` (+`}
          <Currency>{planPrice}</Currency>)
        </span>

        {setIsRemovePPLoading && (
          <button
            aria-label={`Remove 5-year ${planName}`}
            type="button"
            className="text-xs font-bold bg-transparent border-0 text-brand cursor-pointer inline mt-0 mr-0 mb-0 ml-auto pt-0 pr-[5px] pb-0 pl-0 focus:underline"
            onClick={() => {
              setIsRemovePPLoading(true);
            }}
          >
            Remove
          </button>
        )}
      </div>
    )}
  </div>
);

CheckoutSelectedProtectionPlan.propTypes = {
  isRemovePPLoading: PropTypes.bool,
  planName: PropTypes.string,
  planPrice: PropTypes.string,
  setIsRemovePPLoading: PropTypes.func,
};

export default CheckoutSelectedProtectionPlan;
